export default __webpack_public_path__ + "static/media/menu-mobile.a75b92f2.svg";